<template>
    <div>
        <v-data-table
                v-if="invoices"
                :headers="headers"
                :items="invoices"
                :items-per-page="100"
                fixed-header
                :loading="loadingdata"
        >
            <template v-slot:item.name="{ item }">
                <v-btn small outlined text @click="getContact(item)">{{item.name}}</v-btn>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip :color="getColor(item)" dark>{{ item.status }}</v-chip>
            </template>
            <template v-slot:item.invoiceId="{ item } ">
                <a :href='`https://www.paypal.com/invoice/p/#${item.invoiceId}`' target="_blank">
                    {{ new Date(item.createdAt).toDateString()}}
                </a>
            </template>
            <template v-slot:item.text="{ item }">
                <v-btn x-small :disabled="item.paid===1 || ['cancelled','draft'].includes(item.status)" :color="item.textedon?'':'info'" outlined small @click="textNotify(item.invoiceId)">TXT</v-btn>
            </template>
            <template v-slot:item.textedon="{ item }">
                <span v-if="item.textedon">{{ new Date(parseInt(item.textedon)).toDateString()}}</span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn outlined x-small v-if="!item.paid && ['cancelled','draft'].includes(item.status)" @click="Delete(item)">Delete</v-btn>
                <v-btn outlined x-small v-if="!item.paid && item.status=='sent'" @click="confirmMarkPaid(item)">Mark Paid</v-btn>
                <v-btn outlined x-small v-if="(!item.paid && item.status=='sent') || item.status==='draft'" @click="confirmCancel(item)">Cancel</v-btn>
                <v-btn outlined :loading="loading===item.invoiceId" x-small v-if="!item.paid && item.status=='sent'" @click="remind(item.invoiceId)">Remind</v-btn>
                <v-btn outlined x-small v-if="!item.paid && item.status=='draft'" @click="send(item.invoiceId)" :loading="sending===item.invoiceId">
                    Send
                </v-btn>
                <v-btn text small disabled v-if="item.paid">paid</v-btn>
            </template>
            <template v-slot:item.reminded="{ item }">
                <span v-if="item.reminded">{{ new Date(parseInt(item.reminded)).toDateString()}}</span>
            </template>
        </v-data-table>
        <v-dialog v-model="confirmmarkpaiddialog" max-width="600">
            <v-card v-if="invoicedata">
                <v-card-title>Mark {{activeinvoice.invoiceId}} as Paid</v-card-title>
                <v-card-text>
                    Invoice to {{activeinvoice.name}}
                    <div v-for="t in invoicedata.items" >{{t.name+' '+t.quantity+' @ '+t.unit_price.value}}</div>
                    <v-text-field
                            label="Item name"
                            placeholder="Explain"
                            outlined
                            v-model="activeinvoice.note"
                    ></v-text-field>
                    <span class="red--text">{{paiderror}}</span>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="clearActiveInvoice(),confirmmarkpaiddialog=false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="markPaid()" :loading="loading">Mark Paid</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmcanceldialog" max-width="600">
            <v-card>
                <v-card-title>
                    Cancel {{activeinvoice.invoiceId}}
                </v-card-title>
                <v-card-text>
                    Confirm cancel invoice {{activeinvoice.invoiceId}}
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="confirmcanceldialog = false, loading=false" >No (Close)</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancel()" :loading="loading">Yes, Cancel Invoice</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    props:['invoices','loadingdata'],
    name: "InvoiceList",
    components: {},
    data() {
      return {
        sending:false,
        loading:false,
        headers: [
          { text: 'Customer', value: 'name' },
          { text: 'Status', value: 'status' },
          { text: 'Invoice Date', value: 'invoiceId' },
          { text: 'Actions', value: 'actions' },
          { text: 'Reminder Sent', value: 'reminded' },
          { text: 'TXT', value: 'text' },
          { text: 'Text On', value: 'textedon'}
        ],
        payerview:'https://www.paypal.com/invoice/payerView/details/',
        confirmmarkpaiddialog:false,
        confirmcanceldialog:false,
        activeinvoice:{
          data:'',
          invoiceId:''
        },
        invoicedata:{},
        paiderror:''
      }
    },
    computed: {
      ...mapState([])
    },
    methods: {
      ...mapActions(['get', 'post']),
      async remind(inv){
        let data = {
          orgpartkey:'volleyforlife',
          invoiceId:inv
        }//1604949009104
        this.loading=inv;
        let response = await this.post({path:'api/invoicing/remind',body:data})
        let index = this.invoices.findIndex(f=>{return f.invoiceId===inv})
        this.invoices[index].reminded=response.reminded
        this.loading=undefined
      },
      confirmMarkPaid(invoicedata){
        this.activeinvoice = invoicedata;
        console.log('DATA',invoicedata)
        this.invoicedata = JSON.parse(this.activeinvoice.data)
        this.confirmmarkpaiddialog = true;
      },
      async markPaid(){
        let data = {
          invoiceId:this.activeinvoice.invoiceId,
          note:this.activeinvoice.note
        }
        this.loading=true
        let response = await this.post({path:'api/invoicing/markpaid',body:data})
        this.loading=false
        if(response.error){
          this.paiderror = response.error
        } else {
          if(response.httpStatusCode===204){
            for(let i=0;i<this.invoices.length;i++){
              if(this.invoices[i].invoiceId===this.activeinvoice.invoiceId){
                this.invoices[i].paid=1
              }
            }
            this.confirmmarkpaiddialog = false
          }
        }
      },
      confirmCancel(invoicedata){
        this.activeinvoice = invoicedata;
        this.invoicedata = JSON.parse(this.activeinvoice.data)
        this.confirmcanceldialog = true;
      }, //GSM-7 or UCS-2 emoji list
      async cancel(){
        this.loading = true
        let data = {
          invoiceId: this.activeinvoice.invoiceId
        }
        let response = await this.post({path:'api/invoicing/cancel',body:data})
        this.loading=false
        if(response.error){
          this.paiderror = response.error
        } else {
          if(response.httpStatusCode==204){
            let invs = this.invoices;
            for(let i=0;i<invs.length;i++){
              if(invs[i].invoiceId === this.activeinvoice.invoiceId){
                invs[i].status = 'cancelled'
              }
            }
            this.invoices = invs
          }
        }
        this.confirmcanceldialog = false;
      },
      async Delete(item){
        this.loading = true
        let data = {
          invoiceId:item.invoiceId
        }
        let response = await this.delete({path:'api/invoicing/delete',body:data})
        if(response.error){
          this.paiderror = response.error
          return
        }
        this.loading = false
        let t = this.invoices.filter(f=>{return f.invoiceId!=item.invoiceId})
        this.invoices = t
      },
      removeItem(i){
        this.items.splice(i,1)
      },
      async send(inv){
        this.sending = inv
        let data = {
          invoiceId:inv,
        }
        let response = await this.post({path:'api/invoicing/send',body:data})
        this.sending=false
        if(response.httpStatusCode===202){
          let tmp = []
          Object.assign(tmp,this.invoices)
          let index = this.invoices.findIndex(function(f){return f.invoiceId === inv})
          tmp[index].status = 'sent'
          this.invoices = tmp
        }
      },
      async sendtextreminder(){
        return
        //remindAll -- Not Connected yet
        let data = {
          orgpartkey:'volleyforlife',
          code:this.code,
        }
        let response = await this.post({path:'api/invoicing/sendnotification',body:data})
        console.log(this.response)
      },
      async textNotify(inv){
        //sends to ONE customer/contact
        let data = {
          code:this.code,
          invoiceid:inv
        }
        let response = await this.post({path:'api/invoicing/textnotify',body:data})
        if(response.httpStatusCode===202){
          let index = this.invoices.findIndex(function(f){return f.invoiceId === inv})
          let tmpinvoice = this.invoices[index]
          tmpinvoice.textedon = response.textedon
          Object.assign(this.invoices[index], this.editedItem)
        }
      },
      getColor (item) {
        let st = item.status;
        let pd = item.paid
        if (st ==='paid' || pd === 1) { item.status = 'paid'; return 'green darken-2' }
        else if (st === 'sent') return 'red'
        else if (st === 'cancelled') return 'blue-grey lighten-4'
        else return 'orange'
      },
      getDate(dt){
        if(!dt) return ' '
        let d = new Date(dt);
      },
      getContact(item){
        this.getActiveContact(item.uuid)
        this.$router.push('/contacts/edit/'+item.uuid)
      },
      clearActiveInvoice(){
        this.activeinvoice = {
          data:'',
          invoiceId:''
        }
      },
    }
  }

</script>

<style scoped>

</style>